import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getMe } from '../api';

export default function OAuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const { loginUser, loginWithToken } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const errorMsg = searchParams.get('error');

    if (errorMsg) {
      setError(errorMsg);
      return;
    }

    if (!token) {
      setError('No authentication token received');
      return;
    }

    loginWithToken(token);
    getMe()
      .then((data) => {
        loginUser(data);
        navigate('/');
      })
      .catch(() => {
        setError('Failed to load user data. Please try logging in again.');
      });
  }, [searchParams, loginUser, loginWithToken, navigate]);

  if (error) {
    return (
      <div className="auth-container">
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div className="auth-logo">
            <img src="/logo-pocketrams.png" alt="PocketRAMS" />
          </div>
          <div className="alert alert-error" style={{ marginTop: '1rem' }}>{error}</div>
          <a href="/login" className="btn btn-primary btn-full auth-submit" style={{ display: 'block', marginTop: '1rem', textDecoration: 'none' }}>
            Back to Login
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <div className="auth-logo">
          <img src="/logo-pocketrams.png" alt="PocketRAMS" />
        </div>
        <p style={{ marginTop: '1rem', color: '#666' }}>Signing you in...</p>
      </div>
    </div>
  );
}
